import { COLORS } from 'helpers/globals'

export default {
  distanceToSubjectLabelContainer: {
    height: 20,
    position: 'absolute',
    left: 20,
    bottom: 0,
    borderLeft: `1px solid ${COLORS.quaternary}`
  },
  dividerLine: {
    display: 'inline-block',
    position: 'absolute',
    top: 10,
    width: '100%',
    borderTop: `1px dashed ${COLORS.quaternary}`
  },
  distanceToSubjectLabel: {
    height: 20,
    display: 'inline-block',
    lineHeight: '20px',
    verticalAlign: 'top',
    background: 'white',
    position: 'absolute',
    padding: '0 1px'
  },
  distanceToSubjectMarker: {
    position: 'absolute',
    right: -10,
    '& img': {
      height: 20
    }
  },
  sceneHeightLabelContainer: {
    position: 'absolute',
    right: 0,
    borderLeft: `1px dashed ${COLORS.quaternary}`,
    zIndex: -1
  },
  sceneHeightLabel: {
    position: 'absolute',
    right: -10,
    background: 'white'
  }
}



// WEBPACK FOOTER //
// ./src/components/BlindSpotPanelContainer/DowntiltDisplayContainer/SceneHeightLabel/style.js